import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ManIcon(props: IconProps) {
    return <Icon {...props} iconKey={"man"}/>
}
